export enum TransactionStatus {
  SUCCESS = "success",
  PAYMENT_STARTED = "payment_started",
  REQUIRES_USER_AUTHENTICATION = "requires_user_authentication",
  PAYMENT_PENDING = "payment_pending",
  PAYMENT_CONFIRMED = "payment_confirmed",
  FAIL = "fail",
}
